import React from "react"

export type SvgIconProps = {
    iconId: string;
    cssClass?: string;
}

export const SvgIcon = (props: SvgIconProps) => {
    const { iconId, cssClass = "" } = props;
    return (
        <svg className={ `svg-icon svg-icon-text ${cssClass}` } aria-hidden="true" focusable="false">
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={ `#${iconId}` }></use>
        </svg>
    )
}